var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _vm.useStocks && _vm.displayStocks.length
      ? _c("span", [
          _c(
            "a",
            {
              ref: "val",
              staticClass: "d-inline-block",
              attrs: { href: "#" },
              on: {
                mouseenter: _vm.mousenterHandle,
                mouseleave: _vm.mouseleaveHandle,
                click: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c("vue-quantity", {
                attrs: {
                  displayMode: _vm.displayMode,
                  maxQuantity: _vm.maxQuantity,
                  relativeQuantityFactor: _vm.relativeQuantityFactor,
                  quantity: _vm.quantity,
                  measure: _vm.measure,
                  mess: _vm.mess
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.useStocks && _vm.displayStocks.length
            ? _c("span", { staticStyle: { display: "none" } }, [
                _c("span", { ref: "stocks", staticClass: "d-block" }, [
                  _vm.isLoading
                    ? _c("span", { staticClass: "spinner-border" })
                    : _c("span", { staticClass: "d-block" }, [
                        _vm.hasStocks
                          ? _c(
                              "span",
                              { staticClass: "d-block" },
                              _vm._l(_vm.stocks, function(stock) {
                                return _c("span", { key: stock.id }, [
                                  _c("span", { staticClass: "d-block" }, [
                                    _c("span", {
                                      staticClass: "font-weight-bold",
                                      domProps: {
                                        innerHTML: _vm._s(stock.title)
                                      }
                                    }),
                                    _vm._v(
                                      ",\n\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.messages.quantityRest) +
                                        "\n\t\t\t\t\t\t\t\t\t"
                                    ),
                                    _c("b", [
                                      _vm._v(_vm._s(_vm.amounts[stock.id] || 0))
                                    ])
                                  ])
                                ])
                              }),
                              0
                            )
                          : _c("span", { staticClass: "d-block" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.messages.notFound) +
                                  "\n\t\t\t\t\t\t"
                              )
                            ])
                      ])
                ])
              ])
            : _vm._e()
        ])
      : _c(
          "span",
          [
            _c("vue-quantity", {
              attrs: {
                displayMode: _vm.displayMode,
                maxQuantity: _vm.maxQuantity,
                relativeQuantityFactor: _vm.relativeQuantityFactor,
                quantity: _vm.quantity,
                measure: _vm.measure,
                mess: _vm.mess
              }
            })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }